import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";

export default function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Check if already installed as PWA
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    // iOS detection
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(ios);

    // Show banner on mobile (user agent OR small screen)
    const dismissed = localStorage.getItem("pwa-dismissed");
    if (dismissed && Date.now() - parseInt(dismissed) < 7 * 24 * 60 * 60 * 1000) return;

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.innerWidth < 768;
    if (isMobile) setShowBanner(true);

    // Android/Chrome install prompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") setShowBanner(false);
      setDeferredPrompt(null);
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem("pwa-dismissed", Date.now().toString());
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 shadow-lg safe-bottom" data-testid="pwa-install-banner">
      <div className="flex items-center justify-between gap-3 max-w-lg mx-auto">
        <div className="flex items-center gap-3 min-w-0">
          <img src="/icon-192.png" alt="Niello IT" className="w-10 h-10 rounded-lg shrink-0" />
          <div className="min-w-0">
            <p className="font-semibold text-sm text-slate-800 dark:text-white truncate">Install Niello IT</p>
            <p className="text-xs text-slate-500 dark:text-slate-400">
              {isIOS ? 'Tap Share then "Add to Home Screen"' : "Add to your home screen"}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {!isIOS && (
            <Button size="sm" onClick={handleInstall} className="bg-[#7a1d42] hover:bg-[#5a1632] gap-1" data-testid="pwa-install-btn">
              <Download className="w-4 h-4" /> Install
            </Button>
          )}
          <Button size="sm" variant="ghost" onClick={handleDismiss} data-testid="pwa-dismiss-btn">
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
